/**
 * Prefisso dell'area autenticata. '/' è la home pubblica del sito, tutto ciò
 * che richiede il login vive sotto '/app'.
 */
export const APP_BASE = '/app';

/**
 * Restituisce l'URL senza il prefisso APP_BASE ('/app/projects/12' → '/projects/12',
 * '/app' → '/'), per la logica che riconosce la sezione corrente dal percorso.
 */
export function stripAppBase(url: string): string {
  if (url === APP_BASE || url.startsWith(APP_BASE + '?') || url.startsWith(APP_BASE + '#')) {
    return '/' + url.slice(APP_BASE.length);
  }
  if (url.startsWith(APP_BASE + '/')) {
    return url.slice(APP_BASE.length);
  }
  return url;
}
